import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LibraryBacHelperService } from '@app/library/services/library-bac-helper.service';
import { LibraryModalService } from '@app/library/services/library-modal.service';
import { SelectedTracksState } from '@app/library/states/selected-tracks.state';
import { TrashState } from '@app/library/states/trash.state';
import { DndDropEvent } from '@app/shared/modules/dnd/directives/dnd-dropzone.directive';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'rk-library-root-trash',
  templateUrl: './library-root-trash.component.html',
  styleUrls: ['./library-root-trash.component.scss'],
})
export class LibraryRootTrashComponent implements OnInit, OnDestroy {
  @Select(TrashState.archivedTracksLength)
  archivedTracksLength$: Observable<number>;

  @HostBinding('class.active')
  public isActive: boolean;

  @Input()
  radioId: number;

  subscription = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private readonly uiHelper: LibraryBacHelperService,
    private readonly modalService: LibraryModalService,
  ) {}

  ngOnInit() {
    // Listen for route changes
    this.subscription.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (!event.urlAfterRedirects) {
            return;
          }
          this.checkForClasses(event.urlAfterRedirects);
        }
      }),
    );
    this.subscription.add(
      this.route.url.subscribe(() => {
        this.checkForClasses(this.router.url);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkForClasses(url: string): void {
    // set the active route or not
    this.isActive = this.uiHelper.isTrashActive(url);
  }

  dropped(event: DndDropEvent) {
    const selectedTracks = this.store.selectSnapshot(SelectedTracksState.selectedTracks);
    if (selectedTracks.indexOf(event.data.id) > -1 && selectedTracks.length > 1) {
      this.modalService.archiveMultipleTracks(selectedTracks, null);
    } else {
      this.modalService.archiveTrack(event.data, null);
    }
  }
}
